
class solutions {
  _constructor() {
    this.$cardsTrigger = document.querySelectorAll('.solution-card--expand')
    this.$cardsCloseTrigger = document.getElementsByClassName('solution-card--close')
  }

  _openCard($trigger) {
    let $parent = $trigger.parentElement
    $parent.classList.add('solution-card--open')
  }

  _closeCard($trigger) {
    let $parent = $trigger.parentElement.parentElement
    $parent.classList.remove('solution-card--open')
  }

  init() {
    this._constructor()
    const self = this

    if(this.$cardsTrigger !== null) {
      this.$cardsTrigger.forEach(function($card) {
        $card.addEventListener('click', function(event) {
          event.preventDefault()
          self._openCard($card)
        })
      })
    }

    if(this.$cardsCloseTrigger.length > 0) {
      for(let $close of this.$cardsCloseTrigger) {
        $close.addEventListener('click', function(event) {
          event.preventDefault()
          self._closeCard($close)
        })
      }
    }
  }
}
export default solutions
